<template>
    <vue-bottom-sheet ref="iconDetails" @closed="onClosed">
        <div v-if="activeIcon"
             class="menu-item-icon-popup">
            <IconGluttenFreeOutline v-if="activeIcon.name === 'gluten-free'"
                                    width="40"
                                    height="40" />
            <IconPepperHot v-if="activeIcon.name === 'chili-pepper'"
                           width="40"
                           height="40" />
            <IconVegetarian v-if="activeIcon.name === 'vegeterian'"
                            width="40"
                            height="40" />
            <IconLowCal v-if="activeIcon.name === 'low-calories'"
                        width="40"
                        height="40" />
            <h2>{{ $t(activeIcon.name) }}</h2>
            <p>{{ $t(activeIcon.description) }}</p>
        </div>
    </vue-bottom-sheet>
</template>

<script>
import vueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import { lockNav, unlockNav } from "@/utils/navLock";
import IconGluttenFreeOutline from '@/components/icons/IconGluttenFreeOutline.vue';
import IconPepperHot from '@/components/icons/IconPepperHot.vue';
import IconVegetarian from '@/components/icons/IconVegetarian.vue';
import IconLowCal from '@/components/icons/IconLowCal.vue';

export default {
    components: {
        vueBottomSheet,
        IconGluttenFreeOutline,
        IconPepperHot,
        IconVegetarian,
        IconLowCal,
    },
    props: {
        icon: { type: [String, null], default: null },
    },
    data() {
        return {
            iconsOptions: {
                "vegeterian": {
                    "name": "vegeterian",
                    "description": "vegeterian-description",
                },
                "gluten-free": {
                    "name": "gluten-free",
                    "description": "gluten-free-description",
                },
                "chili-pepper": {
                    "name": "chili-pepper",
                    "description": "chili-pepper-description",
                },
                "low-calories": {
                    "name": "low-calories",
                    "description": "low-calories-description",
                },
            },
            activeIcon: null,
        };
    },
    methods: {
        open() {
            this.activeIcon = this.iconsOptions[this.icon];
            lockNav();
            this.$nextTick(() => {
                this.$refs.iconDetails.open();
            });
        },
        onClosed() {
            unlockNav();
        },
    },
};
</script>

<style lang="scss" scoped>
// The bottom-sheet library hardcodes a white card; use the themed surface so the
// sheet follows light/dark mode.
::v-deep .bottom-sheet__card,
::v-deep .bottom-sheet__content {
    background: var(--surface-card) !important;
}

::v-deep .bottom-sheet__content {
    touch-action: none !important;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
        display: none;
    }
}

// Library drag-handle is a dark translucent bar — invisible on the dark card.
::v-deep .bottom-sheet__bar {
    background: var(--border-strong);
}

.menu-item-icon-popup {
    margin-bottom: 30px;
    padding: 0 30px 30px;

    text-align: center;

    // The dish-attribute icons hardcode #656565; recolour just those strokes/fills
    // to the themed secondary token (identical to #656565 in light mode) so they
    // stay legible in dark mode.
    ::v-deep svg [stroke="#656565"] { stroke: var(--text-secondary); }
    ::v-deep svg [fill="#656565"]   { fill: var(--text-secondary); }
}
</style>